import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs';

/** Keep in sync with the `$phone-max` / `$tablet-max` breakpoints in styles.scss. */
export const PHONE_MAX_QUERY = '(max-width: 599.98px)';
export const TABLET_MAX_QUERY = '(max-width: 1023.98px)';

@Injectable({ providedIn: 'root' })
export class BreakpointService {
  private observer = inject(BreakpointObserver);

  /** Phone-sized viewport; use for layout changes CSS alone can't express. */
  readonly isPhone = toSignal(
    this.observer.observe(PHONE_MAX_QUERY).pipe(map((state) => state.matches)),
    { initialValue: this.observer.isMatched(PHONE_MAX_QUERY) }
  );

  /** Phone or tablet viewport. */
  readonly isCompact = toSignal(
    this.observer.observe(TABLET_MAX_QUERY).pipe(map((state) => state.matches)),
    { initialValue: this.observer.isMatched(TABLET_MAX_QUERY) }
  );
}
